<template>
  <div :class="['full-height', backgroundClass]" rounded="0">
    <div class="d-flex flex-column justify-space-between full-height">
      <v-row justify="center" align="center" class="full-width" no-gutters>
        <v-col cols="12" sm="6" md="5" lg="4" xl="4">
          <div class="d-flex justify-center align-center my-3"></div>
          <div
            class="white-background form-card py-9 px-5 rounded"
            :class="{
              'mt-6': !$vuetify.breakpoint.xs,
              'mx-1 ': $vuetify.breakpoint.xs,
            }"
          >
            <v-img
              v-if="client && client.companyPicUrl"
              :src="client.companyPicUrl"
              max-width="165"
              contain
              class="mx-auto"
            />
            <v-img v-else :src="applicationLogoUrl" max-width="165" contain class="mx-auto" />
            <transition :name="slideDirection" mode="out-in">
              <v-row
                v-if="currentSlide == keys.agreements"
                :key="keys.agreements"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center mb-8 text-left"
              >
                <v-card-title
                  v-if="
                    userProfile &&
                    userProfile.Client &&
                    userProfile.Client.onboardingToken &&
                    userProfile.createdBy &&
                    userProfile.createdBy.includes(userProfile.Client.onboardingToken)
                  "
                  class="title-text word-break full-width mb-5"
                  >Let's finish setting up your {{ applicationName }} account</v-card-title
                >
                <v-card-title
                  v-else-if="userProfile && userProfile.Client"
                  class="title-text word-break full-width mb-5"
                  >{{ userProfile.Client.clientName }} has invited you to set up your
                  {{ applicationName }} account</v-card-title
                >
                <v-card-title v-else class="title-text word-break full-width mb-5"
                  >You've been invited to set up your {{ applicationName }} account</v-card-title
                >
                <p v-if="hasPassedKYB && showPaymentsMessaging" class="ml-4">
                  {{ applicationName }} is being used by {{ userProfile.Client.clientName }} to send
                  payments. <br /><br />Once you agree to the terms below, you'll just need to
                  provide some details for your new card!
                </p>
                <p v-else-if="!hasPassedKYB && showPaymentsMessaging" class="ml-4">
                  {{ applicationName }} is being used by {{ userProfile.Client.clientName }} to send
                  payments. After agreeing to the terms below, you can learn more about our app.<br /><br />
                  Once your company has passed a verification process, you can claim your card from
                  the Wallet page.
                </p>
                <p v-else class="ml-4">
                  {{ applicationName }} is being used by {{ userProfile.Client.clientName }} as a
                  powerful learning tool. <br /><br />After agreeing to the terms below, take
                  learning modules provided through the {{ applicationName }} app to enhance your
                  skills!
                </p>
                <v-form ref="form" v-model="validAgreementForm" class="full-width px-4">
                  <div class="d-flex align-center text-left">
                    <v-checkbox
                      v-model="termsCheckbox"
                      class="mt-4 mb-0"
                      :rules="[(v) => !!v || '']"
                    />
                    <span
                      >I agree to the
                      <a @click="downloadFile('privacy_gdpr')">privacy policy</a>
                      and
                      <a @click="downloadFile('terms')">terms and conditions</a></span
                    >
                  </div>
                  <!-- <v-divider />
                  <div class="d-flex align-center">
                    <v-checkbox
                      v-model="privacyCheckbox"
                      class="mt-4"
                      :rules="[(v) => !!v || '']"
                    />
                    <span
                      >I agree to the
                      <a @click="downloadFile('privacy_gdpr')"
                        >privacy policy</a
                      ></span
                    >
                  </div> -->
                </v-form>
              </v-row>
              <v-row
                v-if="currentSlide == keys.newUser"
                :key="keys.newUser"
                no-gutters
                class="pt-8 word-break d-flex flex-column align-center text-center"
              >
                <SignUpForm
                  :additionalFields="additionalFields"
                  :additionalFieldValues="additionalFieldValues"
                  @update:additionalFieldValues="additionalFieldValues = $event"
                  :client="client"
                  :value="validNewUserForm"
                  @input="validNewUserForm = $event"
                  :firstName="firstName"
                  @update:firstName="firstName = $event"
                  :lastName="lastName"
                  @update:lastName="lastName = $event"
                  :email="email"
                  @update:email="email = $event"
                  :country="country"
                  @update:country="country = $event"
                  :otherCountry="otherCountry"
                  @update:otherCountry="otherCountry = $event"
                  :formattedPhone="formattedPhone"
                  @update:formattedPhone="formattedPhone = $event"
                />
              </v-row>
              <v-row
                v-else-if="
                  currentSlide == keys.loading || currentSlide == keys.loadingOnboardingToken
                "
                :key="keys.loading"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center mb-8"
              >
                <v-card-title
                  v-if="currentSlide == keys.loadingOnboardingToken"
                  class="title-text word-break full-width text-left"
                  >Loading your custom signup experience...</v-card-title
                >
                <v-card-title
                  v-else-if="usingOnboardingLink && $auth.isAuthenticated && $route.query.groupId"
                  class="title-text word-break full-width text-left"
                  >Adding you to the group...</v-card-title
                >
                <v-card-title v-else class="title-text word-break full-width text-left"
                  >Setting up your account...</v-card-title
                >

                <Robin
                  :showText="false"
                  :width="140"
                  :height="140"
                  animation="inflatableDance"
                  :loop="true"
                />
              </v-row>
              <v-row
                v-if="currentSlide == keys.verifyEmail"
                :key="keys.verifyEmail"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center mb-8 text-left"
              >
                <v-card-title class="title-text word-break full-width mb-3"
                  >Now just verify your email and set your password
                </v-card-title>
                <div class="accent-background circle-border-radius icon-outer-ring mt-6">
                  <v-icon
                    color="white"
                    x-large
                    class="icon-inner-ring accent-dark-background circle-border-radius"
                    >mdi-email-check-outline</v-icon
                  >
                </div>
                <caption class="mt-12">
                  We sent a verification email to
                  <br />
                  {{
                    email
                  }}
                </caption>

                <p class="font-weight-bold mt-8 text-center">
                  Check your inbox and click on the link inside to get started!
                </p>
                <p
                  class="cursor-pointer primary--text font-weight-bold"
                  @click="
                    (currentSlide = keys.error),
                      (displayEmailButton = true),
                      (errorMessage = `If you continue to not receive your ${this.applicationName} email invitation, please contact us`)
                  "
                >
                  Email did not arrive?
                </p>
              </v-row>
              <v-row
                v-if="currentSlide == keys.creationSuccess && client.onboardingApprovalQueueEnabled"
                :key="keys.creationSuccess + '-review'"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center mb-8 text-center"
              >
                <Typography variant="h-1" class="pt-8">Thanks for signing up!</Typography>
                <Typography variant="h-5" class="pt-8 pb-8">
                  Your account is in review. Look out for an invitation email when approval is
                  granted.
                </Typography>
                <Robin
                  :showText="false"
                  :width="140"
                  :height="140"
                  animation="inflatableDance"
                  :loop="true"
                />
              </v-row>
              <v-row
                v-else-if="currentSlide == keys.creationSuccess"
                :key="keys.creationSuccess"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center mb-8 text-center"
              >
                <v-card-title class="title-text word-break mb-3 text-center">
                  You're all set!
                </v-card-title>
                <div class="accent-background circle-border-radius icon-outer-ring mt-6">
                  <v-icon
                    color="white"
                    x-large
                    class="icon-inner-ring accent-dark-background circle-border-radius"
                    >mdi-check</v-icon
                  >
                </div>

                <!-- <p class="font-weight-bold mt-8 text-center">
                  Check your inbox and click on the link inside to get started!
                </p> -->

                <Button @click="loadLoginPage" class="mt-12">Go to {{ applicationName }}</Button>
              </v-row>
              <v-row
                v-if="currentSlide == keys.groupConfirmation"
                :key="keys.groupConfirmation"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center mb-8 text-center"
              >
                <v-card-title class="title-text word-break mb-3 text-center">
                  Looks like you're already signed into {{ applicationName }}
                </v-card-title>

                <div class="accent-background circle-border-radius icon-outer-ring mt-6">
                  <v-icon
                    color="white"
                    x-large
                    class="icon-inner-ring accent-dark-background circle-border-radius"
                    >mdi-account-multiple</v-icon
                  >
                </div>
                <p class="pl-4 full-width mt-8">Do you want to join this group?</p>
              </v-row>
              <v-row
                v-else-if="currentSlide == keys.error"
                :key="keys.error"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center mb-8 text-left"
              >
                <v-card-title class="title-text word-break" v-if="!errorMessage"
                  >Looks like your account needs some extra attention</v-card-title
                >
                <v-card-title class="title-text word-break" v-else>{{ errorMessage }}</v-card-title>

                <div v-if="showHelpContactInfo">
                  <CustomerServiceContact layout="stacked" class="pl-4 full-width mt-8" />
                </div>
                <div class="d-flex mt-6">
                  <Button
                    v-if="displayEmailButton"
                    :loading="sendingResetEmail"
                    @click="sendResetEmail"
                  >
                    Resend Email
                  </Button>
                  <Button v-else-if="displayLoginButton" @click="loginOrLogout"> Log In </Button>
                  <Button
                    v-else-if="displayEditButton"
                    @click="(currentSlide = keys.newUser), (displayEditButton = false)"
                  >
                    Edit Details
                  </Button>
                  <Button v-else-if="displayBackToLoginButton" @click="loginOrLogout"
                    >Back to Login</Button
                  >
                </div>
              </v-row>
              <v-row
                v-else-if="currentSlide == keys.card"
                :key="keys.card"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center justify-start"
              >
                <!-- <div class="d-flex flex-column align-center"> -->
                <v-card-title class="title-text word-break mt-8">Claim your card</v-card-title>
                <div
                  class="brand-light-green-background circle-border-radius icon-outer-ring mt-10"
                >
                  <v-icon
                    color="white"
                    x-large
                    class="icon-inner-ring brand-green-background circle-border-radius"
                    >mdi-credit-card-outline</v-icon
                  >
                </div>
                <p class="mt-12" v-if="hasPassedKYB">
                  To receive funds, we need some info.<br /><br />The card is your personal card, so
                  make sure to set it up with with your personal info and not work info.
                </p>
                <p class="mt-12" v-else>
                  Before you can claim your card, your organization has to pass a verification
                  process.
                </p>
                <p class="pt-18" v-if="hasPassedKYB">
                  This can also be done later on from the Wallet page.
                </p>
                <p class="mt-18" v-else>
                  Once that is done, check on the Wallet page to claim your card!
                </p>
              </v-row>
              <v-row
                v-else-if="currentSlide == keys.success"
                :key="keys.success"
                no-gutters
                class="py-3 word-break d-flex flex-column align-center justify-start"
              >
                <!-- <div class="d-flex flex-column align-center"> -->
                <v-card-title class="title-text word-break mt-8">Congratulations!</v-card-title>
                <div
                  class="brand-light-green-background circle-border-radius icon-outer-ring mt-10"
                >
                  <v-icon
                    color="white"
                    x-large
                    class="icon-inner-ring brand-green-background circle-border-radius"
                    >fa-check</v-icon
                  >
                </div>
                <caption class="mt-12">
                  You are all set to begin using
                  {{
                    applicationName
                  }}
                </caption>
              </v-row>
            </transition>
            <v-row
              class="mb-6"
              align="center"
              justify="center"
              v-if="
                currentSlide != keys.loading &&
                currentSlide != keys.loadingOnboardingToken &&
                currentSlide != keys.error &&
                currentSlide != keys.verifyEmail &&
                currentSlide != keys.creationSuccess &&
                currentSlide != keys.success
              "
            >
              <v-col>
                <Button
                  outlined
                  v-if="currentSlide == keys.card"
                  :disabled="currentSlide == keys.agreements && !validAgreementForm"
                  @click="nextSlide(true)"
                  ><span>Later</span></Button
                >
                <Button
                  outlined
                  v-else-if="currentSlide == keys.groupConfirmation"
                  :disabled="currentSlide == keys.agreements && !validAgreementForm"
                  @click="loginOrLogout"
                  ><span>Log out</span></Button
                >
                <Button
                  :disabled="
                    (currentSlide == keys.newUser && !validNewUserForm) ||
                    (currentSlide == keys.agreements && !validAgreementForm) ||
                    (currentSlide == keys.card && !hasPassedKYB)
                  "
                  :loading="loadingKYB"
                  @click="nextSlide"
                  ><span>{{
                    currentSlide == keys.card
                      ? "Claim Card"
                      : currentSlide == keys.groupConfirmation
                      ? "Yes"
                      : "Sign up"
                  }}</span></Button
                >
                <div v-if="currentSlide == keys.newUser" class="pt-8">
                  <v-divider class="pb-8" />
                  <CustomerServiceContact />
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="my-3">
            <p
              class="white--text cursor-pointer font-weight-bold mb-1"
              @click="downloadFile('terms')"
            >
              Terms and Conditions
            </p>
            <p
              v-if="!$auth.isAuthenticated"
              class="white--text cursor-pointer font-weight-bold"
              @click="loginOrLogout"
            >
              Already have an account?
            </p>
            <p v-else class="white--text cursor-pointer font-weight-bold" @click="loginOrLogout">
              Log out
            </p>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      fullscreen
      v-model="dialogCardRequest"
      transition="dialog-bottom-transition"
      class="z-index-front"
    >
      <v-card>
        <MarqetaCardRequest
          v-if="dialogCardRequest"
          :cards="marqeta.cards"
          :alreadyRegistered="marqeta.alreadyRegistered"
          @reset="closeKYB"
        ></MarqetaCardRequest>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { languages } from "@/shared_data/data.js";
import Button from "@/components/generic/Button.vue";

import Robin from "@/components/Robin.vue";
import MarqetaCardRequest from "@/components/wallet/MarqetaCardRequest";
import CustomerServiceContact from "@/components/help/CustomerServiceContact";

import moment from "moment";
import { mapState } from "vuex";
import Typography from "@/components/generic/Typography.vue";

import UserService from "@/services/UserService";
import ClientService from "@/services/ClientServiceV2";
import TriggerService from "@/services/TriggerService";
import OnboardingService from "@/services/OnboardingService";

import SignUpForm from "@/components/account-management/SignUpForm.vue";
import gradientBackgroundMixin from "@/mixins/gradientBackground";
import whitelabelMixin from "@/mixins/whitelabelMixin";

export default {
  name: "ActivationV2",
  title: "Setup",
  props: {
    alreadyRegistered: Boolean,
    cards: Array,
  },
  components: {
    Robin,
    MarqetaCardRequest,
    SignUpForm,
    Button,
    Typography,
    CustomerServiceContact,
  },
  mixins: [gradientBackgroundMixin, whitelabelMixin],
  data() {
    return {
      clientService: new ClientService(),

      currentSlide: 0,
      keys: {
        // First screen always. Shows agreements
        agreements: 0,
        // When saving agreements
        loading: 1,
        // Intro to card screen
        card: 2,
        // card success screen. Will show for a few seconds and immediately route
        success: 3,
        // general error screen
        error: 4,
        // Loading page to indicate that we're fetching the client based on the onboarding token
        loadingOnboardingToken: 5,
        // User signup/creation screen for brand new users that route from an onboarding token url param
        newUser: 6,
        // Email verification screen once user created their acct
        verifyEmail: 7,
        // Success screen after onboarding to take them to the login page
        creationSuccess: 8,
        // Group confirmation if user is logged in
        groupConfirmation: 9,
      },

      // CONSTANTS
      languages,

      slideDirection: "topic-left",

      errorMessage: null,
      validAgreementForm: false,

      language: null,
      clientId: null,

      termsCheckbox: false,
      termsSupplementalId: null,
      // privacyCheckbox: false,
      privacySupplementalId: null,

      dialogCardRequest: false,
      loadingKYB: false,

      // v-form to validate
      validNewUserForm: false,
      // data fields to set up the new user.
      firstName: null,
      lastName: null,
      email: null,
      formattedPhone: null,
      country: null,
      otherCountry: null,
      additionalFields: [],
      additionalFieldValues: [],
      // Client object stored so we have their logo to display
      client: {},
      // Error handling booleans
      displayLoginButton: false,
      displayEditButton: false,
      displayEmailButton: false,
      displayBackToLoginButton: false,
      showHelpContactInfo: false,
      // Loading bool for when resending password reset
      sendingResetEmail: false,
    };
  },
  created() {
    this.language = "en-US";
    this.country = "US";
    // If the user is using an onboarding link, we fetch that client first
    if (
      (this.$route.name == "user-signup" || this.$route.name == "user-signup-static") &&
      this.$route.params &&
      this.$route.params.onboardingToken
    ) {
      this.getClientFromOnboardingLink();
    }
    if (this.$auth.isAuthenticated) {
      // Preload terms and privacy supplemental data
      if (this.userProfile && this.userProfile.UserSupplementals) {
        var userSupp = this.userProfile.UserSupplementals;
        var terms = userSupp.find((x) => x.key === "Terms and Conditions Agreement");
        if (terms) {
          this.termsSupplementalId = terms.userSupplementalId;
        } else {
          this.termsSupplementalId = null;
        }

        var privacy = userSupp.find((x) => x.key === "Privacy Policy Agreement");
        if (privacy) {
          this.privacySupplementalId = privacy.userSupplementalId;
        } else {
          this.privacySupplementalId = null;
        }
      }

      if (
        this.privacySupplementalId &&
        this.termsSupplementalId &&
        this.userProfile.clientId != 1 &&
        (!this.userProfile.Client ||
          (this.userProfile.Client &&
            this.userProfile.Client.clientName != "Rainforest QA Test Environment" &&
            this.userProfile.Client.clientName != "Demo Co")) &&
        !this.usingOnboardingLink
      ) {
        if (this.showPaymentsMessaging) {
          if (
            !this.hasPassedKYB ||
            (this.marqeta.alreadyRegistered && this.marqeta.cards.length > 0)
          ) {
            this.completeOnboardingFlow();
          } else {
            this.currentSlide = this.keys.card;
          }
        } else {
          this.completeOnboardingFlow();
        }
      }
      console.log(this.userProfile);
      if (
        this.currentSlide == this.keys.agreements &&
        this.userProfile.UserSupplementals.length == 0
      ) {
        this.insertActivity("FIRST_LOGIN");
      }
      // Update user status
      // if (
      //   !actionTaken &&
      //   this.privacySupplementalId &&
      //   this.termsSupplementalId &&
      //   (this.userProfile.platformStatus == "ACCOUNT_CREATION" ||
      //     this.userProfile.platformStatus == "EMAIL_VERIFIED")
      // ) {
      //   this.updateUser({
      //     platformStatus: "AGREEMENTS_SIGNED",
      //     platformStatusUpdateDate: moment().utc(),
      //   });
      // } else if (
      //   !actionTaken &&
      //   (this.userProfile.platformStatus === null ||
      //     this.userProfile.platformStatus == "ACCOUNT_CREATION")
      // ) {
      //   // This is their first login so update as email verified
      //   this.updateUser({
      //     platformStatus: "EMAIL_VERIFIED",
      //     platformStatusUpdateDate: moment().utc(),
      //   });
      // }
    }
  },
  mounted() {
    //Move the fresh works help widget
    var freshworks = document.querySelector("#launcher-frame");
    if (freshworks) {
      freshworks.style.right = "-55px";
      freshworks.style["max-width"] = freshworks.style["min-width"] = "90px";
    }
  },
  unmounted() {
    // window.divNode.parentNode.removeChild(window.divNode);
    var freshworks = document.querySelector("#launcher-frame");
    if (freshworks) {
      freshworks.style.right = "22px";
    }
  },
  methods: {
    loginOrLogout() {
      if (!this.$auth.isAuthenticated) {
        //Logs in
        this.$auth.loginWithEmbedded({
          connection: process.env.VUE_APP_ENVIRONMENT,
        });
      } else {
        //Logs out
        this.$auth.logout({
          returnTo: window.location.origin,
        });
      }
    },
    scrollToTop() {
      // if (!this.$vuetify.breakpoint.sm && !this.$vuetify.breakpoint.xs) {
      //   document.getElementsByClassName(
      //     "v-dialog v-dialog--active"
      //   )[0].scrollTop = 0;
      // } else {
      //   console.log("Scrolling on mobile");
      //   const cardY = document.getElementById("progress-bar");
      //   const rect = cardY.getBoundingClientRect();
      //   console.log(rect.top);
      //   window.scrollTo(0, rect.top - 90);
      // }
    },
    nextSlide(exit = false) {
      this.slideDirection = "topic-left";
      if (exit === true) {
        this.completeOnboardingFlow();
      } else if (this.currentSlide == this.keys.card) {
        // open up the dialog window
        this.loadingKYB = true;
        this.dialogCardRequest = true;
      } else if (this.usingOnboardingLink) {
        if (
          this.currentSlide == this.keys.newUser ||
          this.currentSlide == this.keys.groupConfirmation
        )
          this.createUserFromOnboardingLink();
      } else {
        this.scrollToTop();
        this.currentSlide += 1;

        if (this.currentSlide == this.keys.loading) {
          // We are submitting agreements
          this.saveAgreements();
        } else if (this.currentSlide == this.keys.success + 1) {
          console.log("All done");
          this.completeOnboardingFlow();
        }
      }
    },
    insertActivity(event) {
      var obj = {
        userId: this.userProfile.userId,
        clientId: this.userProfile.clientId,
        event: event,
        source: "USER_ONBOARDING",
        category: "PLATFORM",
        date: new Date(),
      };
      TriggerService.createActivity(obj, this.magicLinkToken)
        .then((response) => {
          console.log("Response from inserting activity ", response);
        })
        .catch((error) => {
          console.log("There was an error inserting activity ", error);
        });
    },
    saveAgreements() {
      var startTime = new Date();
      var userSuppArray = [
        {
          userId: this.userProfile.userId,
          key: "Terms and Conditions Agreement",
          value: moment().utc(),
          updatedBy: this.userProfile.userId,
        },
        {
          userId: this.userProfile.userId,
          key: "Privacy Policy Agreement",
          value: moment().utc(),
          updatedBy: this.userProfile.userId,
        },
      ];
      if (this.termsSupplementalId !== null) {
        userSuppArray[0].userSupplementalId = this.termsSupplementalId;
      }
      if (this.privacySupplementalId !== null) {
        userSuppArray[1].userSupplementalId = this.privacySupplementalId;
      }

      console.log("Updating/Creating User Supplemental: ", userSuppArray);
      UserService.bulkUpdateUserSupplemental(userSuppArray, this.magicLinkToken)
        .then((response) => {
          console.log("User Supplemental response: ", response);
          var timeDiff = moment().diff(moment(startTime));
          if (timeDiff > 1500) {
            timeDiff = 1500;
          }
          setTimeout(() => {
            // If there was an error with the API, we show the error page
            if (response.error) {
              this.currentSlide = this.keys.error;
            } else {
              // If we're not ready for them to request a card, then we take them to the succes page.
              if (this.showPaymentsMessaging && this.hasPassedKYB) {
                this.currentSlide = this.keys.card;
                // this.updateUser({
                //   platformStatus: "AGREEMENTS_SIGNED",
                //   platformStatusUpdateDate: moment().utc(),
                // });
              } else {
                this.completeOnboardingFlow();
              }
            }
          }, 1500 - timeDiff);
        })
        .catch((error) => {
          console.log("There was an error saving user supplemental: ", error);
          this.currentSlide = this.keys.error;
        });
    },
    downloadFile(name) {
      OnboardingService.downloadLegalDoc(name);
    },
    closeKYB(success) {
      this.dialogCardRequest = false;

      if (success) {
        this.completeOnboardingFlow(success);
      } else {
        this.loadingKYB = false;
      }
      this.$store.dispatch("setMarqeta").then((x) => {
        if (x.cards.length > 0) {
          this.completeOnboardingFlow(true);
        }
        this.loadingKYB = false;
      });
    },
    completeOnboardingFlow(loadVirtualCard = false) {
      this.currentSlide = this.keys.success;
      // We have to mark them as having logged in
      // Completed the onboarding setup
      // Then push them to People
      var startTime = new Date();
      UserService.updateUser(
        this.userProfile.userId,
        {
          firstLogin: false,
          updatedBy: this.userProfile.userId,
        },
        this.magicLinkToken
      )
        .then((user) => {
          console.log("User update response: ", user);

          // this.$store.dispatch("setUser", this.userProfile.userId).then((x) => {
          // console.log("Done with getting user", x);
          var timeDiff = moment().diff(moment(startTime));
          if (timeDiff > 1500) {
            timeDiff = 1500;
          }
          setTimeout(() => {
            // Route to client default
            // checks if we're not already on the current route. Vuetify errors if we try to route user to the route they're currently on
            // If they're using a magic link, we only need to take them to activity or wallet
            if (
              this.magicLinkToken &&
              (this.magicLinkRoute == "/wallet" || this.magicLinkRoute == "/activity")
            ) {
              if (this.$route.path != this.magicLinkRoute) this.$router.puush(this.magicLinkRoute);
            } else {
              if (
                this.$route.name != this.userProfile.Client.initialRouteOnLoad &&
                // The exception being procore
                this.$route.name != "procore"
              )
                this.$router.push({
                  name: this.userProfile.Client.initialRouteOnLoad,
                });
            }
            if (loadVirtualCard) {
              this.$store.state.displayWalletMenu = true;
              this.$store.state.walletMenuScreen = "display-virtual";
            }
            // Then I manually flip the boolean that is forcing this onboarding flow to show up so it takes the user to the app
            this.$store.state.userProfile.firstLogin = false;
          }, 1500 - timeDiff);
          // });
        })
        .catch((error) => {
          console.log("Error completing onboarding: ", error);
          return (this.currentSlide = this.keys.error);
        });
    },
    sendResetEmail() {
      this.sendingResetEmail = true;
      UserService.resetPassword(this.email).then((x) => {
        console.log("Password reset email ", x);
        this.sendingResetEmail = false;
      });
    },
    async getClientFromOnboardingLink() {
      try {
        var startTime = new Date();
        let onboardingToken = this.$route.params.onboardingToken;

        this.currentSlide = this.keys.loadingOnboardingToken;
        this.errorMessage = "Uh oh, we couldn't find your signup experience";
        this.client = {};

        console.log("Getting client based on onboarding link: ", onboardingToken);
        let response = await (this.$route.name == "user-signup-static"
          ? this.clientService.getClientByPersistentOnboardingTokenV3
          : this.clientService.getClientByOnboardingTokenV3)(onboardingToken);
        console.log("Client response: ", response);
        var timeDiff = moment().diff(moment(startTime));
        if (timeDiff > 1500) timeDiff = 1500;

        setTimeout(() => {
          //  If we got a client back, everything is normal. If no clients were returned then we throw an error
          if (response.result) {
            console.log("Found a client! ", response.result);
            this.client = response.result;
            this.errorMessage = null;
            this.currentSlide =
              this.$auth.isAuthenticated && this.$route.query.groupId
                ? this.keys.groupConfirmation
                : this.keys.newUser;
            this.additionalFields =
              this.client.ClientRegistrationFormFields?.filter(
                (field) => field.status === "Active"
              ) || [];

            this.additionalFieldValues = this.additionalFields.map((field) => {
              return {
                userAttribute: field.userAttribute,
                value: undefined,
              };
            });
          } else {
            // No client found
            console.log("No clients found with onboarding token");
            this.currentSlide = this.keys.error;
          }
        }, 1500 - timeDiff);
      } catch (err) {
        console.log("Error getting client from onboarding token", err);
        this.currentSlide = this.keys.error;
      }
    },
    async createUserFromOnboardingLink() {
      try {
        var startTime = new Date();
        let onboardingToken = this.$route.params.onboardingToken;

        this.currentSlide = this.keys.loading;

        let user = {
          firstName: this.firstName,
          lastName: this.lastName,
          businessEmail: this.formattedPhone ? null : this.email,
          businessPhone: this.formattedPhone,
          businessCountry: this.country != "00" ? this.country : this.otherCountry,
          ...this.additionalFieldValues.reduce((acc, field) => {
            acc[field.userAttribute] = field.value;
            return acc;
          }, {}),
        };
        console.log("Creating user based on onboarding link: ", user);
        let response = await OnboardingService.createUserFromOnboardingLink(
          onboardingToken,
          user,
          this.$route.name == "user-signup-static",
          // Only append groupId if they're authetnicated and there's a groupId in the route
          this.$route.name == "user-signup-static" &&
            this.$route.query.groupId &&
            this.$auth.isAuthenticated
            ? this.$route.query.groupId
            : null,
          this.$route.query
        );
        console.log("User creation response: ", response);
        var timeDiff = moment().diff(moment(startTime));
        if (timeDiff > 1500) timeDiff = 1500;

        setTimeout(() => {
          //  If we got a client back, everything is normal. If no clients were returned then we throw an error

          this.errorMessage = null;
          this.currentSlide = this.keys.creationSuccess;
          // this.keys.verifyEmail;
        }, 1500 - timeDiff);
      } catch (err) {
        console.log("Error creating user from onboarding token");
        this.errorMessage = "Uh oh, we had trouble setting up your account";
        this.currentSlide = this.keys.error;

        if (err.error_code && err.error_code.endsWith("022")) {
          this.errorMessage = "We found an account matching the email you entered.";
          this.showHelpContactInfo = true;
          this.displayLoginButton = true;
        } else if (err.error_code && err.error_code.endsWith("011")) {
          this.errorMessage = "The email you entered does not appear to be valid.";
          this.showHelpContactInfo = true;
          this.displayEditButton = true;
        } else if (err.error_code && err.error_code.endsWith("194")) {
          this.errorMessage = "Uh oh, we couldn't find your signup experience";
          this.showHelpContactInfo = true;
        } else if (err.error_code && err.error_code.endsWith("207")) {
          this.errorMessage =
            "Your account is still in review. Look out for an invitation email when approval is granted.";
          this.displayBackToLoginButton = true;
        } else if (err.error_code && err.error_code.endsWith("208")) {
          this.errorMessage = "Your account request was denied.";
          // #188258 Shape D: a component cannot be used inside a JS string, so
          // the contact invitation moves to the showHelpContactInfo block, which
          // the three sibling error branches above already use. This drops the
          // clause "If you believe this is a mistake, please contact support at
          // ..." - per the AC that whole sentence is a per-screen contact lead-in
          // to be replaced, but the "if you believe this is a mistake" nuance is
          // genuinely lost. Flagged on the PR for Product.
          this.showHelpContactInfo = true;
          this.displayBackToLoginButton = true;
        }
      }
    },
    loadLoginPage() {
      this.$router.push({
        name: "login",
        params: {
          email: this.formattedPhone || this.email,
        },
      });
    },
  },
  computed: {
    ...mapState(["userProfile", "marqeta", "permissions", "magicLinkToken", "magicLinkRoute"]),
    disableNextButton() {
      return (
        (this.currentSlide == this.keys.user && !this.validAgreementForm) ||
        (this.currentSlide == this.keys.agreements &&
          (!this.cardholderAgreement || !this.eSignAgreement || !this.issuerPrivacyPolicy))
      );
    },
    hasPassedKYB() {
      if (this.marqeta && this.marqeta.canRegister) {
        return true;
      }
      return false;
    },
    showPaymentsMessaging() {
      if (
        this.userProfile?.Client?.onboardingLanguage?.toLowerCase()?.includes("payment") ||
        this.client?.onboardingLanguage?.toLowerCase()?.includes("payment")
      ) {
        return true;
      } else {
        return false;
      }
    },
    usingOnboardingLink() {
      return (this.$route.name == "user-signup" || this.$route.name == "user-signup-static") &&
        this.$route.params.onboardingToken
        ? true
        : false;
    },
  },

  watch: {},
};
</script>

<style scoped>
.box-outline {
  border: solid;
  border-color: lightgray;
  border-width: 2px;
  background-color: white;
}

.form-card {
  min-height: 550px;
  height: calc(100% - 100px);
}

.icon-outer-ring {
  width: 110px;
  height: 110px;
}

.large-icon {
  transform: scale(1.5);
}

.icon-inner-ring {
  width: 94px;
  margin: 8px;
  height: 94px;
}

.title-text {
  font-size: 1.4em;
}

/* Code for transitions between slides */
.topic-left-enter {
  opacity: 0;
  transform: translateX(100%);
}

.topic-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.topic-left-enter-active,
.topic-right-enter-active {
  transition: all 0.65s cubic-bezier(0.19, 1, 0.22, 1);
}

.warning-background {
  background-color: #ffb74d;
}

.warning-dark-background {
  background-color: #f57c00;
}
</style>
